import type { GQL } from '@aline/graphql';

import type { UUID } from '../../types/type-helpers';
import type { ProcessTemplateField, ProcessTemplateInitialValue } from '../internal';

type CheckboxInitialValue = Extract<ProcessTemplateInitialValue, { type: 'checkbox' }>;

/**
 * Resolves how a checkbox field should be initialized when processing a template.
 * Returns null for fields that carry no checkbox initialization data, so callers keep
 * the template's existing options and checked state.
 */
export function getCheckboxInitialValue(
  field: ProcessTemplateField | undefined
): CheckboxInitialValue | null {
  if (field?.initialValue?.type !== 'checkbox') return null;

  return field.initialValue;
}

/**
 * Index input fields from the DB by nodeRefId -> field so its an easy lookup when we
 * perform editor operations.
 */
export function indexFieldsByNodeRefId<
  T extends
    | Pick<GQL.DocumentVariable, 'nodeId' | '__typename'>
    | Pick<GQL.SignatureField, 'nodeId' | '__typename'>,
>(inputFields: T[]): Record<UUID, T> {
  return inputFields.reduce<Record<UUID, T>>((nodeRefIdToField, field) => {
    nodeRefIdToField[field.nodeId] = field;
    return nodeRefIdToField;
  }, {});
}
